import React from 'react';
import classes from './styles.module.scss';
import DailyCheckinIcon from '../../assets/icons/daily-checkin.svg';
import OfferRewardIcon from '../../assets/icons/offer-reward.svg';
import PaymentRefundedIcon from '../../assets/logo/pro-logo.svg';
import ReferalIcon from '../../assets/icons/referral.svg';

const TYPE_AND_ICON_MAP = {
  OFFER_REWARD: {
    icon: OfferRewardIcon,
  },
  DAILY_CHECKIN: {
    icon: DailyCheckinIcon,
  },
  REFERRAL: {
    icon: ReferalIcon,
  },
  TRANSACTION_REVERSAL: {
    icon: PaymentRefundedIcon,
  },
};

export default function SourceTypeToSVG({ data }) {
  return (
    <div className={classes.icon}>
      <img
        src={
          data.offIconUrl
            ? data.offIconUrl
            : TYPE_AND_ICON_MAP[data.sourceEntityType]
            ? TYPE_AND_ICON_MAP[data.sourceEntityType].icon
            : TYPE_AND_ICON_MAP['TRANSACTION_REVERSAL'].icon
        }
        alt="source type"
        height="40px"
        width="100%"
      />
    </div>
  );
}
